import React from "react";
import "../Styles/Privacy.css";

const PrivacyPolicy = () => {
  return (
   <>
     <div className="privacy-image">
        <img src="./corporate/privacy.png " alt="" />
      </div>

    <div className="privacy-page">
      <div className="privacy-container">

        <h5 className="company-name">Swastika Infra Limited</h5>

        <h1 className="page-title">Privacy Policy</h1>
        <div className="title-underline"></div>

        {/* <p className="effective-date">
          Effective Date: [Add Date]
        </p> */}

        <p>
          At Swastika Infra, accessible from www.swastikainfra.com,
          one of our main priorities is the privacy of our visitors.
          This Privacy Policy document contains types of information
          that are collected and recorded by Swastika Infra and how we use it.
        </p>

        <h3>1. Information We Collect</h3>
        <p>
          We may collect personal information such as name, phone number,
          email address, address, and any details submitted through contact forms.
          We only collect information when you voluntarily provide it to us.
        </p>

        <h3>2. How We Use Your Information</h3>
        <p>
          We use the collected information to respond to inquiries,
          improve our website and services, contact you regarding projects
          or services, and send updates if applicable.
          We do not sell or rent users’ personal information to others.
        </p>

        <h3>3. Log Files</h3>
        <p>
          Swastika Infra follows a standard procedure of using log files.
          These may include IP address, browser type, ISP, date and time stamp,
          and pages visited. This data is used for analytics purposes.
        </p>

        <h3>4. Cookies</h3>
        <p>
          Our website may use cookies to enhance user experience.
          You can disable cookies through your browser settings.
        </p>

        <h3>5. Third-Party Services</h3>
        <p>
          We may use third-party services such as Google Analytics
          or social media platforms. These services have their own
          privacy policies which we do not control.
        </p>

        <h3>6. Data Security</h3>
        <p>
          We take appropriate security measures to protect your personal
          information. However, no method of transmission over the internet
          is 100% secure.
        </p>

        <h3>7. External Links</h3>
        <p>
          Our website may contain links to external websites.
          We are not responsible for their privacy practices.
        </p>

        <h3>8. Children’s Information</h3>
        <p>
          We do not knowingly collect personal information from children under 13.
        </p>

        <h3>9. Consent</h3>
        <p>
          By using our website, you consent to our Privacy Policy.
        </p>

        <h3>10. Updates</h3>
        <p>
          We may update this Privacy Policy from time to time.
          Any changes will be posted on this page.
        </p>

        <h3>Contact Us</h3>
        <p>
          Email:info@swastikainfra.com<br />
          Phone: [0141-4025773]
        </p>

      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;
